import { render, staticRenderFns } from "./TextGraphicSection.vue?vue&type=template&id=6f368b16&scoped=true&"
import script from "./TextGraphicSection.vue?vue&type=script&lang=js&"
export * from "./TextGraphicSection.vue?vue&type=script&lang=js&"
import style0 from "./TextGraphicSection.vue?vue&type=style&index=0&id=6f368b16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f368b16",
  null
  
)

export default component.exports